// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-tooltip {
  position: absolute;
  background: #fff;
  border: 1px solid #eee;
  padding: 5px;
}`, "",{"version":3,"sources":["webpack://./src/markdown/tooltip-plugin.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EAEA,gBAAA;EACA,sBAAA;EACA,YAAA;AAAD","sourcesContent":[".editor-tooltip {\n\tposition: absolute;\n\n\tbackground: #fff;\n\tborder: 1px solid #eee;\n\tpadding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
